module.exports = __webpack_public_path__ + "static/media/wares.dc1d2192.jpg";